
import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";


export const drawdown = async (withdrawDetails: {amount: number, loanId: number}): Promise<string> => {
  const res = await axiosInstance.request({
    baseURL: gatewayUrl,
    url: `/kuber/drawdown`,
    method: "post",
    data: withdrawDetails
  });
  return res.data;
};

export const getDrawdownInfo = async (loan_id: number, amount: number): Promise<{convenienceFee: number, convenienceFeeGst: number}> => {
  const res = await axiosInstance.request({
    baseURL: gatewayUrl,
    url: "kuber/pre-drawdown-info",
    method: "GET",
    params: {
      loan_id,
      amount
    },
  });
  return res.data;
}
